export {
    default as Languages,
    ILanguagesProps,
} from './languages';
